import { render, staticRenderFns } from "./agentPublishesNoticeDetails.vue?vue&type=template&id=2562aa32&scoped=true"
import script from "./agentPublishesNoticeDetails.vue?vue&type=script&lang=js"
export * from "./agentPublishesNoticeDetails.vue?vue&type=script&lang=js"
import style0 from "./agentPublishesNoticeDetails.vue?vue&type=style&index=0&id=2562aa32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2562aa32",
  null
  
)

export default component.exports